export default function HTMLTitle({value}: { value: string }) {
  return <span dangerouslySetInnerHTML={{__html: value}}/>;
}